<template>
    <div>
        <div class="form-horizontal" encregion="multipart/form-data" @submit.prevent="store"
             @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="websiteService in websiteServices">
                    <td>
                        <input type="text" v-if="websiteService.editable" class="form-control"
                               :name="websiteService.value" v-model="form['value'][websiteService.id]">
                        <span v-if="!websiteService.editable">{{ websiteService.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeWebsiteService(websiteService)"
                           class="btn btn-danger" v-if="websiteService.deleteable"
                           :title="uLang('app.delete_website_service')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newWebsiteService"
                           :placeholder="uLang('app.new_website_service')"
                           :title="uLang('app.add_new_website_service')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addWebsiteService"
                                :disabled="form.busy">{{
                                uLang('app.create_entity', {entity: lang('app.website_service')})
                            }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()"
                       class="btn btn-brand"/>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '~/Form/Form'
import {ErrorAlert, SuccessAlert, DestroyAlert} from '~/Swals'
import {AlphabeticalSort} from '~/mixins'

export default {
    props: {
        settingId: {
            required: true,
        },
    },
    mixins: [
        AlphabeticalSort
    ],
    data() {
        return {
            form: new Form({
                value: {},
            }),
            newWebsiteService: '',
            websiteServices: []
        }
    },
    mounted: function () {
        this.retrieveValues();
    },
    methods: {
        async store() {
            this.form['patch']('/api/admin/settings/' + this.settingId)
                .then(response => {
                    this.setValues(response);
                    new SuccessAlert({text: this.uLang('app.entity_updated', {entity: lang('app.website_services')})}).show();
                })
                .catch(error => {
                    new ErrorAlert({
                        title: uLang('app.oops_something_went_wrong'),
                        text: uLang('app.all_inputs_need_to_be_filled'),
                    }).show();
                });
        },

        setValues(data) {
            data = this.alphabeticalSort(data)

            this.form.value = {};

            this.websiteServices = data;

            data.forEach(function (websiteService) {
                if (websiteService.editable) {
                    this.value[websiteService.id] = websiteService.value;
                }

            }, this.form);

        },

        async retrieveValues() {
            // TODO: Check if this basic setting logic happens in other components, and maybe move to mixin
            const {data} = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

            this.setValues(data);
        },

        addWebsiteService() {
            if (this.newWebsiteService === '')
                return;


            this.websiteServices.push(
                {
                    id: this.newWebsiteService,
                    value: this.newWebsiteService,
                    deleteable: 1,
                    editable: 1
                }
            );
            this.form.value[this.newWebsiteService] = this.newWebsiteService;
            this.newWebsiteService = '';
        },

        removeWebsiteService(websiteService) {
            new DestroyAlert({entity: this.lang('app.website_service')}).show().then(async () => {

                delete this.form.value[websiteService.id];

                //remove the websiteService from the table
                this.websiteServices = this.websiteServices.filter(function (current_website_service) {
                    return current_website_service.value != websiteService.value;
                });
            })
        }
    }
}
</script>

<style lang="css" scoped>

</style>
